import {
    Component,
    ViewEncapsulation,
    Injector,
    ViewChild,
    OnInit,
    NgModule,
} from "@angular/core";
import { appModuleAnimation } from "@shared/animations/routerTransition";
import { AppComponentBase } from "@shared/common/app-component-base";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
    EventsServiceProxy,
    UserAddressDto,
    UserPhoneDto,
    CreditCardPaymentDto,
    CouponsServiceProxy,
    EventCategoryDeadlineDto,
    EventPaymentMethodPermissionDto,
    UpdatePaymentInput,
    PaymentDto,
    RegistrationsServiceProxy,
    CreateOrEditRegistrationDto,
    EventToSignUpDto,
    UserServiceProxy,
    UserSelectListDto,
    RegistrationUserDto,
    CategoryServiceProxy,
    CreateOrEditRegistrationByAdminDto,
    RegistrationUserMemberEditDto,
    MemberCategoryEditDto,
    RegistrationUserEditDto,
    UserListDto,
    EventListDto,
    RegistrationEventDto,
    CreateOrEditRegistrationOutput,
    RegistrationDto,
    NoteDto,
    UserEmailDto,
    DebitCardPaymentDto,
} from "@shared/service-proxies/service-proxies";
import { CorreiosService } from "@app/shared/common/correios/correios.service";
import {
    AppUserAddressDtoType,
    PaymentMethod,
    AppPhoneType,
    StatusIntegracao,
} from "@shared/AppEnums";
import { EventInformationsModalComponent } from "@app/event/event-informations-modal/event-informations-modal.component";
import { PhonesComponent } from "@app/shared/common/phones/phones.component";
import { ReceiptModalComponent } from "@app/financial/receivables/modals/receipt/receipt-modal.component";
import { FileDownloadService } from "@shared/utils/file-download.service";

import * as _ from "lodash";
import * as moment from "moment";
import {
    CartHelperService,
    IRegistrationCart,
} from "@app/store/cart/cart-helper-service";
import { Observable } from "rxjs/Observable";
import { EmailsComponent } from "@app/shared/common/emails/emails.component";
import { LoginService } from "account/login/login.service";

@Component({
    templateUrl: "./registration.component.html",
    styles: [
        `
            .alert-coupon {
                padding: 0;
                padding: 7px 14px;
            }
        `,
    ],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
})
export class RegistrationComponent extends AppComponentBase implements OnInit {
    @ViewChild("eventInformationsModal")
    eventInformationsModal: EventInformationsModalComponent;
    @ViewChild("receiptModal") receiptModalComponent: ReceiptModalComponent;
    @ViewChild("emails") emails: EmailsComponent;
    @ViewChild("phones") phones: PhonesComponent;

    paymentMethod = PaymentMethod;
    appUserAddressDtoType = AppUserAddressDtoType;
    emailDto = UserEmailDto;
    phoneDto = UserPhoneDto;
    statusIntegracao = StatusIntegracao;

    isAdmin = false;

    registration: CreateOrEditRegistrationByAdminDto;
    payment: PaymentDto;
    note: NoteDto;
    messageRegistration: CreateOrEditRegistrationOutput = undefined;

    currentDate = moment(moment().format("YYYY-MM-DD"));

    eventId: number;
    event: EventToSignUpDto;
    userId: number;
    registrationId: number = 0;
    creditCardPayment: CreditCardPaymentDto;
    debitCardPayment: DebitCardPaymentDto;

    countries: any[] = CorreiosService.loadCountries();
    brazilStates = CorreiosService.loadBrazilStates();
    citiesFromState = [];
    deadlines: EventCategoryDeadlineDto[] = [];
    saving = false;
    contractTerms = false;

    externalAccessToken = "";
    couponCode = "";
    canShowErrorCoupon = false;
    hasCouponApplied = false;

    categoryDeadline: EventCategoryDeadlineDto = undefined;

    paymentMethodSelected: EventPaymentMethodPermissionDto = undefined;
    couponPaymentMethodPermission = undefined;
    ticketPaymentMethodPermission = undefined;
    creditCardPaymentMethodPermission = undefined;
    debitCardPaymentMethodPermission = undefined;
    paymentMethodsAdmin = [];
    creditCardBrands = [];
    debitCardBrands = [];

    users = [];
    events = [];
    categories = [];

    eventToRegistration = undefined;
    userToRegistration = undefined;
    memberCategory = undefined;
    categoryLevelId = undefined;

    userLogged = this.appSession.user;
    searchUser = undefined;
    userLoaded = false;

    cart = undefined;

    admin = false;
    onLocal = false;
    approvedRegistration = false;

    emitCredential = true;
    emitReceipt = true;

    // TODO: Inserir alteração de usuário para o segundo item do carrinho
    changeUser = true;

    constructor(
        injector: Injector,
        private route: ActivatedRoute,
        private _eventsService: EventsServiceProxy,
        private _registrationsService: RegistrationsServiceProxy,
        private _correiosService: CorreiosService,
        private _couponsService: CouponsServiceProxy,
        private _router: Router,
        private _userService: UserServiceProxy,
        private _categoryService: CategoryServiceProxy,
        private _cartHelperService: CartHelperService,
        private _fileDownloadService: FileDownloadService,
        public _loginService: LoginService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.isAdmin = this.isGrantedAny(
            "Pages.Events.Registrations.Management",
            "Pages.Events.Registrations.RegistrationOnLocal"
        );
        this.route.queryParams.subscribe((params: Params) => {
            this.eventId = +params["eventId"];
            this.userId = +params["userId"];
            this.externalAccessToken = params["token"];
            this.registrationId = +params["registrationId"];
            this.admin = params["admin"] == "true" && this.isAdmin;
            this.onLocal = params["onLocal"] == "true" && this.isAdmin;
        });

        if (!this.externalAccessToken)
            this.externalAccessToken = this.route.snapshot.queryParams['token'];

        if (this.externalAccessToken && !this.appSession.userId) {
            this.login();
        }

        this.cart = this._cartHelperService.getCart(this.onLocal);
        abp.event.trigger("app.cart.refresh");

        this.loadCategories();
    }

    //Login with token
    login(): void {
        this.loading = true;
        this._loginService.authenticateModel.userNameOrEmailAddress = "login"; //UserName genérico
        this._loginService.authenticateModel.token = this.externalAccessToken;
        this._loginService.authenticateModel.password = "congress2023"; //Senha para login sem password
        this._loginService.authenticateModel.refererUrl = window.location.href;
        this._loginService.authenticate(() => {
            this.loading = false;
        });
    }

    loadCategories() {
        this._categoryService
            .getForSelect("", undefined, true, false)
            .subscribe((result) => {
                this.categories = result.items;

                this.loadSubscription();
            });
    }

    loadSubscription(): void {
        this.userToRegistration = undefined;
        this.payment = new PaymentDto();
        this.payment.paidDate = moment().startOf("day");
        this.creditCardPayment = new CreditCardPaymentDto();
        this.debitCardPayment = new DebitCardPaymentDto();

        if (!this.userLogged && !this.eventId) {
            this._router.navigate(["app/event/signUp"]);
        }

        if (!this.userId) {
            this.userId = abp.session.userId;
        }

        if (this.eventId) {
            this.loadEventForSubscription();
        } else if (!this.admin && !!this.userId) {
            this.loadUserForSubscription();
        }
    }

    loadUserForSubscription(onlyCheckApproved?: boolean): void {
        if (
            this.registration &&
            this.registration.user &&
            onlyCheckApproved == undefined
        ) {
            this.registration.user.emails = undefined;
            this.registration.user.phones = [];
        }

        this._registrationsService
            .getUserForRegistration(this.userId, this.eventId, undefined)
            .subscribe((result) => {
                this.userLoaded = true;
                this.approvedRegistration = result.hasRegistration;

                if (onlyCheckApproved == undefined) {
                    this.registration =
                        new CreateOrEditRegistrationByAdminDto();
                    this.registration.user = result as RegistrationUserEditDto;
                    this.registration.eventId = this.eventId;

                    this.adjustUser();
                    this.loadCitiesFromState();
                    this.loadDeadline();
                }
            });
    }

    loadDeadline() {
        if (
            !this.categoryDeadline &&
            this.event &&
            this.event.categoryDeadlines.length == 1
        ) {
            this.categoryDeadline = this.event.categoryDeadlines[0];
            this.calculateValue();
        }
    }

    adjustUser() {
        if (this.registration.user.phones.length == 0) {
            let phone = new UserPhoneDto();
            phone.type = AppPhoneType.Mobile;
            phone.ddi = "55";
            this.registration.user.phones.push(phone);
        }

        if (!this.registration.user.address.id) {
            this.registration.user.address = new UserAddressDto();
            this.registration.user.address.countryName = "BRASIL";
            this.registration.user.address.type = AppUserAddressDtoType.Home;
            this.registration.user.address.isMailing = true;
        }

        if (this.registration.user.emails == undefined) {
            this.registration.user.emails = [];
        }
    }

    loadEventForSubscription() {
        this._eventsService
            .getEventForSignUp(this.eventId)
            .catch((error) => {
                this._router.navigate(["app/event/signUp"]);
                return Observable.throw(error);
            })
            .subscribe((result) => {
                this.eventToRegistration = {
                    id: result.event.id,
                    name: result.event.name,
                };

                this.event = result.event;
                this.deadlines = result.event.categoryDeadlines;
                this.paymentMethodsAdmin = [];

                this.event.paymentMethods.forEach((paymentMethodPermission) => {
                    if (paymentMethodPermission.isAllowed == true) {
                        if (
                            paymentMethodPermission.paymentMethod
                                .paymentMethodType != PaymentMethod.Coupon
                        )
                            this.paymentMethodsAdmin.push(
                                paymentMethodPermission
                            );

                        if (
                            paymentMethodPermission.paymentMethod
                                .paymentMethodType == PaymentMethod.Coupon
                        ) {
                            this.couponPaymentMethodPermission =
                                paymentMethodPermission;
                        } else if (
                            paymentMethodPermission.paymentMethod
                                .paymentMethodType == PaymentMethod.CreditCard
                        ) {
                            this.creditCardPaymentMethodPermission =
                                paymentMethodPermission;
                            this.creditCardBrands =
                                paymentMethodPermission.paymentMethod.cardBrands;
                        } else if (
                            paymentMethodPermission.paymentMethod
                                .paymentMethodType == PaymentMethod.DebitCard
                        ) {
                            this.debitCardPaymentMethodPermission =
                                paymentMethodPermission;
                            this.debitCardBrands =
                                paymentMethodPermission.paymentMethod.cardBrands;
                        } else if (
                            paymentMethodPermission.paymentMethod
                                .paymentMethodType == PaymentMethod.Ticket
                        ) {
                            this.ticketPaymentMethodPermission =
                                paymentMethodPermission;
                        }
                    }
                });

                if (
                    this.ticketPaymentMethodPermission &&
                    !this.creditCardPaymentMethodPermission
                ) {
                    this.paymentMethodSelected =
                        this.ticketPaymentMethodPermission;
                } else if (
                    !this.ticketPaymentMethodPermission &&
                    this.creditCardPaymentMethodPermission
                ) {
                    this.paymentMethodSelected =
                        this.creditCardPaymentMethodPermission;
                }

                let registrationCart = this._cartHelperService.getRegistration(
                    this.eventId
                );

                if (registrationCart) {
                    this.userId = this.cart.user.id;
                    this.categoryDeadline = registrationCart.categoryDeadline;
                    this.categoryDeadline.deadline = moment(
                        this.categoryDeadline.deadline
                    );

                    registrationCart.registration.user =
                        new RegistrationUserEditDto();
                    registrationCart.registration.user.id = this.cart.user.id;
                    registrationCart.registration.user.name =
                        this.cart.user.name;
                    registrationCart.registration.user.nameForCredential =
                        this.cart.user.nameForCredential;
                    registrationCart.registration.user.userName =
                        this.cart.user.userName;
                    registrationCart.registration.user.emailAddress =
                        this.cart.user.emailAddress;
                    registrationCart.registration.user.address =
                        this.cart.user.address;
                    registrationCart.registration.user.emails =
                        this.cart.user.emails;
                    registrationCart.registration.user.phones =
                        this.cart.user.phones;
                    registrationCart.registration.event = undefined;
                    registrationCart.registration.eventId = this.eventId;
                    registrationCart.registration.categoryDeadlineId =
                        this.categoryDeadline.id;

                    if (registrationCart.registration.coupon) {
                        registrationCart.registration.coupon.expirationDate =
                            moment(
                                registrationCart.registration.coupon
                                    .expirationDate
                            );
                        this.hasCouponApplied = true;
                    }

                    if (!this.cart.user.id) {
                        this.categories.forEach((category) => {
                            if (
                                category.id ==
                                this.cart.user.member.categories[0].categoryId
                            )
                                this.memberCategory = category;
                        });
                        this.categoryLevelId =
                            this.cart.user.member.categories[0].categoryLevelId;
                    } else this.loadUserForSubscription(true);

                    this.userToRegistration = new UserSelectListDto();
                    this.userToRegistration.id = this.cart.user.id;
                    this.userToRegistration.name = this.cart.user.name;
                    this.userToRegistration.userName = this.cart.user.userName;

                    this.loadRegistrationSaved(registrationCart.registration);
                    this.contractTerms = true;
                } else if (this.registrationId > 0) {
                    this._registrationsService
                        .getForEdit(this.registrationId)
                        .subscribe((result) => {
                            this.loadRegistrationSaved(result.registration);
                        });
                } else if (this.cart && this.cart.user) {
                    this.registration =
                        new CreateOrEditRegistrationByAdminDto();
                    this.registration.eventId = this.eventId;
                    this.registration.user = new RegistrationUserEditDto();
                    this.registration.user.id = this.cart.user.id;
                    this.registration.user.name = this.cart.user.name;
                    this.registration.user.nameForCredential =
                        this.cart.user.nameForCredential;
                    this.registration.user.userName = this.cart.user.userName;
                    this.registration.user.emailAddress =
                        this.cart.user.emailAddress;
                    this.registration.user.address = this.cart.user.address;
                    this.registration.user.emails = this.cart.user.emails;
                    this.registration.user.phones = this.cart.user.phones;

                    this.loadCitiesFromState();

                    if (!this.cart.user.id) {
                        this.categories.forEach((category) => {
                            if (
                                category.id ==
                                this.cart.user.member.categories[0].categoryId
                            )
                                this.memberCategory = category;
                        });
                        this.categoryLevelId =
                            this.cart.user.member.categories[0].categoryLevelId;
                    } else {
                        this.userId = this.cart.user.id;
                        this.loadUserForSubscription(true);
                    }

                    this.userToRegistration = new UserSelectListDto();
                    this.userToRegistration.id = this.cart.user.id;
                    this.userToRegistration.name = this.cart.user.name;
                    this.userToRegistration.userName = this.cart.user.userName;
                } else if (!this.admin && this.userId)
                    this.loadUserForSubscription();
            });
    }

    loadRegistrationSaved(registration): void {
        if (registration.user || this.userId) {
            this.registration =
                registration as CreateOrEditRegistrationByAdminDto;

            this.loadCitiesFromState();

            this.paymentMethodSelected = registration.paymentMethod;

            if (this.registration.coupon) {
                this.hasCouponApplied = true;
                this.couponCode = this.registration.coupon.code;
            }

            this.event.categoryDeadlines.forEach((categoryDeadlineSelected) => {
                if (
                    categoryDeadlineSelected.id ==
                    this.registration.categoryDeadlineId
                ) {
                    this.categoryDeadline = categoryDeadlineSelected;
                }
            });

            this.calculateValue();
        } else {
            this.loadUserForSubscription();
        }
    }

    save(): void {
        this.saving = true;

        if (this.payment.totalPaid > 0) {
            this.registration.paymentMethod = undefined;
            this.registration.paymentMethodId = this.paymentMethodSelected.id;
            this.registration.creditCardPayment = undefined;

            if (
                !this.admin &&
                this.paymentMethodSelected &&
                this.paymentMethodSelected.paymentMethod.paymentMethodType ==
                PaymentMethod.CreditCard
            ) {
                this.registration.creditCardPayment =
                    new CreditCardPaymentDto();
                this.registration.creditCardPayment.cardExpirationDate = moment(
                    "01/" + this.creditCardPayment.cardExpirationDate,
                    "DD/MM/YYYY"
                );
                this.registration.creditCardPayment.cardNumber =
                    this.creditCardPayment.cardNumber;
                this.registration.creditCardPayment.cpf =
                    this.creditCardPayment.cpf;
                this.registration.creditCardPayment.creditCardBrand =
                    this.creditCardPayment.creditCardBrand;
                this.registration.creditCardPayment.holderName =
                    this.creditCardPayment.holderName;
                this.registration.creditCardPayment.securityCode =
                    this.creditCardPayment.securityCode;
                this.registration.creditCardPayment.numberOfInstallments =
                    this.creditCardPayment.numberOfInstallments > 1
                        ? this.creditCardPayment.numberOfInstallments
                        : undefined;
            }
        } else if (
            this.registration.coupon &&
            this.registration.coupon.discountAmount >= this.payment.totalPaid
        ) {
            this.registration.paymentMethodId =
                this.couponPaymentMethodPermission.id;
        }

        this.registration.user.emails.forEach((email) => {
            email.id = undefined;
        });

        this.registration.user.phones.forEach((phone) => {
            phone.id = undefined;
        });

        this.registration.categoryDeadlineId = this.categoryDeadline.id;

        if (!this.registration.user.id) {
            this.registration.user.member = new RegistrationUserMemberEditDto();
            this.registration.user.member.categories = [];

            let category = new MemberCategoryEditDto();
            category.categoryId = this.memberCategory.id;
            category.categoryLevelId = this.categoryLevelId;

            this.registration.user.member.categories.push(category);
        }

        if (this.admin) {
            this.saveAdmin();
        } else {
            this._registrationsService
                .createOrEdit(this.registration)
                .finally(() => {
                    this.saving = false;
                })
                .subscribe((result) => {
                    if (result.registrationId > 0) {
                        this.registrationId = result.registrationId;
                        this.registration.id = result.registrationId;
                    }

                    if (!result.success) {
                        this.message.warn(this.l(result.message));
                    } else {
                        this.notify.info(this.l("SavedSuccessfully"));

                        if (result.html) {
                            // If return ticket

                            var _win = window.open("", "SHOPLINE" + Date.now());

                            if (!!_win) {
                                this.message.success(
                                    this.l(
                                        "Registration successfully registered."
                                    )
                                );
                                _win.document.write(result.html);
                                this._router.navigate(["app/event/signUp"]);
                            } else {
                                this.message.warn(
                                    this.l(
                                        "The pop‐ups is bloked. For generate the ticket is necessary enable pop‐ups in your navigator and try again."
                                    ),
                                    this.l("Warning!")
                                );
                            }
                        } else {
                            this.message.success(
                                this.l("Registration successfully registered.")
                            );
                            this._router.navigate(["app/event/signUp"]);
                        }
                    }
                });
        }
    }

    validateCoupon(): void {
        if (this.couponCode) {
            this._couponsService
                .validateCouponByCode(this.couponCode, this.eventId)
                .subscribe((result) => {
                    if (!result.code) {
                        this.canShowErrorCoupon = true;
                        this.registration.coupon = undefined;
                    } else {
                        this.canShowErrorCoupon = false;
                        this.registration.coupon = result;

                        if (result.discountAmount >= this.payment.totalPaid)
                            this.payment.totalPaid = 0;
                    }
                    this.calculateValue();
                });
        } else {
            this.registration.coupon = undefined;
            this.canShowErrorCoupon = false;
            this.calculateValue();
        }
    }

    calculateValue(): void {
        let input = new UpdatePaymentInput();
        input.payment = this.payment;

        input.coupon = this.registration.coupon;
        input.categoryDeadLine = this.categoryDeadline;
        input.paymentMethodPermissionId =
            !this.admin && this.paymentMethodSelected
                ? this.paymentMethodSelected.id
                : undefined;
        input.payment.appliedDiscount = input.payment.appliedDiscount
            ? input.payment.appliedDiscount
            : 0;
        this.registration.categoryDeadlineId = this.categoryDeadline.id;

        this._registrationsService
            .updateRegistrationPaymentValuesAsync(input)
            .subscribe((result) => {
                this.payment = result;

                if (this.registration.user.id) {
                    this._registrationsService
                        .checkExistingRegistration(this.registration)
                        .subscribe((result) => {
                            this.messageRegistration = result;
                        });
                }
            });
    }

    // Calculate Total Paid
    calculateTotalPaid(): void {
        this.payment.totalPaid =
            this.categoryDeadline.value - this.payment.appliedDiscount;
    }

    verifyCardExpirationDate(): void {
        let date = moment(
            "01/" + this.creditCardPayment.cardExpirationDate,
            "DD/MM/YYYY"
        );
        if (!date.isValid())
            this.creditCardPayment.cardExpirationDate = undefined;
    }

    // Address
    loadCitiesFromState() {
        if (this.isBrasil()) {
            this._correiosService
                .loadCities(this.registration.user.address.stateAbbreviation)
                .then((cities) => {
                    this.citiesFromState = cities;
                });
        }
    }

    loadCities() {
        let stateAbbreviation =
            this.registration.user.address.stateAbbreviation;

        if (this.isBrasil()) {
            this._correiosService
                .loadCities(stateAbbreviation)
                .then((cities) => {
                    this.citiesFromState = cities;
                    this.setValueStateName();
                });
        } else this.registration.user.address.stateName = stateAbbreviation;
    }

    clearStateAndCity() {
        this.registration.user.address.stateName = "";
        this.registration.user.address.stateAbbreviation = "";
        this.registration.user.address.city = "";
        this.registration.user.address.zipCode = "";
    }

    setValueStateName() {
        this.brazilStates.forEach((state) => {
            if (
                state.abbreviation ==
                this.registration.user.address.stateAbbreviation
            ) {
                this.registration.user.address.stateName = state.name;
            }
        });
    }

    searchZipCode() {
        let zipCode = this.registration.user.address.zipCode;

        if (zipCode && zipCode.length >= 8) {
            this._correiosService.searchByPostalCode(zipCode).then((result) => {
                let data = result[0];

                if (!!data) {
                    this.registration.user.address.city =
                        data.Municipio.toUpperCase();
                    this.registration.user.address.complement =
                        data.Complemento.toUpperCase();
                    this.registration.user.address.district =
                        data.Bairro.toUpperCase();
                    this.registration.user.address.logradour =
                        data.Logradouro.toUpperCase();
                    this.registration.user.address.stateAbbreviation =
                        data.Estado.toUpperCase();
                    this.registration.user.address.stateName =
                        data.Estado.toUpperCase();
                    this.registration.user.address.countryName = "BRASIL";
                }

                this.loadCities();
            });
        }
    }

    isBrasil(): boolean {
        return this.registration.user.address.countryName == "BRASIL";
    }

    formEmailsIsInvalid(): boolean {
        return this.emails && this.emails.emailsForm.invalid;
    }

    formPhonesIsInvalid(): boolean {
        return this.phones && this.phones.phonesForm.invalid;
    }

    formIsValid(formValid: boolean): boolean {
        return (
            formValid &&
            !this.formPhonesIsInvalid() &&
            !this.formEmailsIsInvalid()
        );
    }

    // Get Events
    filterEvents(event): void {
        this._eventsService
            .getEventsForSelect(
                event.query,
                0,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                10,
                0
            )
            .subscribe((result) => {
                this.events = result.items;
            });
    }

    // Get Users
    filterUsers(event): void {
        this._userService
            .getUsersForSelect(event.query, undefined, 20, 0)
            .subscribe((result) => {
                this.unBlock(".m-portlet");

                if (
                    result.items.length == 0
                    //|| (event.query.length == 8 && isNaN(Number(event.query))) ||
                    // (event.query.length == 11 && !isNaN(Number(event.query)))
                    //&& !isNaN(Number(event.query))
                ) {
                    let newUser = new UserSelectListDto();
                    newUser.name = this.l("New User");
                    newUser.userName = event.query;
                    this.users = [];
                    this.users.push(newUser);
                } else {
                    this.users = result.items;
                }

                if (!this.userLogged) {
                    this.userToRegistration = new UserSelectListDto();
                    this.userToRegistration.id = this.users[0].id;
                    this.userToRegistration.name = this.users[0].name;
                    this.userToRegistration.userName = this.users[0].userName;
                    this.onSelectUser();
                    this.loadDeadline();
                    setTimeout(() => {
                        $("[name='emailAddressUser']").focus();
                    }, 0);
                }
            });
    }

    checkSearchUser(): void {
        if (
            (this.searchUser &&
                this.searchUser.length == 8 &&
                isNaN(Number(this.searchUser))) ||
            (this.searchUser.length == 11 && !isNaN(Number(this.searchUser)))
        ) {
            this.block(".m-portlet");

            let search = { query: this.searchUser };
            this.filterUsers(search);

            if (this.searchUser.length == 8) {
                this.getCategories("Estra");
                this.deadlines = this.event.categoryDeadlines.filter((x) =>
                    x.description.includes("stra")
                );
            } else {
                this.getCategories("");
                if (this.event && this.event.categoryDeadlines.length)
                    this.deadlines = this.event.categoryDeadlines;
            }
        }
    }

    getCategories(term: string) {
        this._categoryService
            .getForSelect(term, undefined, true, false)
            .subscribe((result) => {
                this.categories = result.items;
            });
    }

    onBlurEvent(): void {
        if (!this.eventToRegistration || !this.eventToRegistration.id) {
            this.eventId = undefined;
        }
        else {
            this.eventId = this.eventToRegistration.id;
        }
    }


    onSelectEvent(event: any): void {

        if(this.eventId != this.eventToRegistration.id){
            this.eventId = this.eventToRegistration.id;
            this.eventToRegistration = this.events.find(e => e.id === this.eventToRegistration.id);
            this.loadEventForSubscription();
        }
    }

    onSelectUser(): void {
        this.couponCode = undefined;
        this.memberCategory = undefined;
        this.categoryDeadline = undefined;
        this.messageRegistration = undefined;
        this.paymentMethodSelected = undefined;
        this.approvedRegistration = false;

        if (this.userToRegistration.id) {
            this.userId = this.userToRegistration.id;
            if (!this.userLogged) {
                this._router.navigate(["account/login"], {
                    queryParams: { id: this.userToRegistration.userName },
                });
            }

            this.loadUserForSubscription();
        } else {
            this.registration = new CreateOrEditRegistrationByAdminDto();
            this.registration.user = new RegistrationUserEditDto();
            this.registration.user.userName = this.userToRegistration.userName;
            this.registration.user.emails = undefined;
            this.registration.user.phones = [];
            this.registration.user.address = new UserAddressDto();
            this.registration.eventId = this.eventId;

            setTimeout(() => {
                this.userLoaded = true;
                this.adjustUser();
            }, 0);
        }
    }

    clearUser(): void {
        this._cartHelperService.clearCart();
        abp.event.trigger("app.cart.refresh");
        this.userToRegistration = undefined;
        this.approvedRegistration = false;

        if (this.registration) this.registration.user = undefined;
    }

    checkUser(): void {
        setTimeout(() => {
            if (!this.userToRegistration) this.clearUser();
        }, 0);
    }

    clearCategoryLevelId(): void {
        this.categoryLevelId = undefined;

        if (this.memberCategory.levels.length > 0) {
            setTimeout(() => {
                this.categoryLevelId = this.memberCategory.levels[0].id;
            }, 0);
        }
    }

    saveAdmin() {
        this.saving = true;

        let registrationByAdmin = new CreateOrEditRegistrationByAdminDto();
        registrationByAdmin.user = this.registration
            .user as RegistrationUserEditDto;
        registrationByAdmin.eventId = this.eventId;
        registrationByAdmin.categoryDeadlineId =
            this.registration.categoryDeadlineId;
        registrationByAdmin.coupon = this.registration.coupon;
        registrationByAdmin.paymentMethodId = this.registration.paymentMethodId;
        registrationByAdmin.note = this.registration.note;

        if (
            this.registration.coupon &&
            this.registration.coupon.discountAmount >= this.payment.totalPaid
        ) {
            this.paymentMethodSelected = this.couponPaymentMethodPermission;
        }

        if (this.paymentMethodSelected) {
            this.payment.paymentMethodId =
                this.paymentMethodSelected.paymentMethodId;
        }

        registrationByAdmin.payments = [];

        if (
            this.admin &&
            this.paymentMethodSelected &&
            this.paymentMethodSelected.paymentMethod.paymentMethodType ==
            PaymentMethod.CreditCard
        ) {
            registrationByAdmin.creditCardPayment = new CreditCardPaymentDto();
            registrationByAdmin.creditCardPayment.paidDate = moment();
            registrationByAdmin.creditCardPayment.cardExpirationDate = moment();
            registrationByAdmin.creditCardPayment.cardNumber = "************";
            registrationByAdmin.creditCardPayment.cpf =
                this.registration.user.userName;
            registrationByAdmin.creditCardPayment.creditCardBrand =
                this.creditCardPayment.creditCardBrand;
            registrationByAdmin.creditCardPayment.holderName =
                this.registration.user.name;
            registrationByAdmin.creditCardPayment.securityCode = "123";
            registrationByAdmin.creditCardPayment.numberOfInstallments =
                this.creditCardPayment.numberOfInstallments > 1
                    ? this.creditCardPayment.numberOfInstallments
                    : 1;
            registrationByAdmin.creditCardPayment.paymentMethodId =
                this.paymentMethodSelected.paymentMethodId;
            registrationByAdmin.creditCardPayment.totalPaid =
                this.payment.totalPaid;
            registrationByAdmin.creditCardPayment.appliedDiscount =
                this.payment.appliedDiscount;

            registrationByAdmin.payments.push(
                registrationByAdmin.creditCardPayment
            );
        } else if (
            this.admin &&
            this.paymentMethodSelected &&
            this.paymentMethodSelected.paymentMethod.paymentMethodType ==
            PaymentMethod.DebitCard
        ) {
            registrationByAdmin.debitCardPayment = new DebitCardPaymentDto();
            registrationByAdmin.debitCardPayment.paidDate = moment();
            registrationByAdmin.debitCardPayment.cardExpirationDate = moment();
            registrationByAdmin.debitCardPayment.cardNumber = "************";
            registrationByAdmin.debitCardPayment.cpf =
                this.registration.user.userName;
            registrationByAdmin.debitCardPayment.cardBrand =
                this.creditCardPayment.creditCardBrand;
            registrationByAdmin.debitCardPayment.holderName =
                this.registration.user.name;
            registrationByAdmin.debitCardPayment.securityCode = "123";
            registrationByAdmin.debitCardPayment.numberOfInstallments = 1;
            registrationByAdmin.debitCardPayment.paymentMethodId =
                this.paymentMethodSelected.paymentMethodId;
            registrationByAdmin.debitCardPayment.totalPaid =
                this.payment.totalPaid;
            registrationByAdmin.debitCardPayment.appliedDiscount =
                this.payment.appliedDiscount;

            registrationByAdmin.payments.push(
                registrationByAdmin.debitCardPayment
            );
        } else {
            registrationByAdmin.payments.push(this.payment);
        }

        if (!registrationByAdmin.user.id) {
            registrationByAdmin.user.member =
                new RegistrationUserMemberEditDto();
            registrationByAdmin.user.member.categories = [];

            let category = new MemberCategoryEditDto();
            category.categoryId = this.memberCategory.id;
            category.categoryLevelId = this.categoryLevelId;

            registrationByAdmin.user.member.categories.push(category);
        }

        this._registrationsService
            .createOrEditByAdmin(registrationByAdmin)
            .finally(() => {
                this.saving = false;
            })
            .subscribe((result) => {
                if (!result.success) {
                    this.message.warn(this.l(result.message));
                } else {
                    if (this.emitCredential)
                        this.generateCredential(result.registrationId);

                    if (this.payment.totalPaid > 0 && this.emitReceipt) {
                        this.receiptModalComponent.show(
                            result.registrationId,
                            registrationByAdmin.user.name
                        );
                    } else {
                        this.clearFormAdmin();
                    }
                }
            });
    }

    clearFormAdmin(): void {
        this.userToRegistration = undefined;
        this.registration = undefined;
        this.categoryDeadline = undefined;
        this.paymentMethodSelected = undefined;
        this.couponCode = undefined;
        this.creditCardPayment.creditCardBrand = undefined;
        this.creditCardPayment.installments = undefined;
        this.debitCardPayment.cardBrand = undefined;
        this.debitCardPayment.installments = undefined;

        this.payment = new PaymentDto();
        this.payment.paidDate = moment().startOf("day");
    }

    checkContractTerms(): void {
        if (this.contractTerms) {
            $("#modal_terms").modal("show");
        }
    }

    closeModalTerms(): void {
        $("#modal_terms").modal("hide");
    }

    backToEvent(): void {
        this._router.navigate(["app/event/signUp"]);
    }

    addToCart(): void {
        this.saving = true;

        if (
            this.payment.totalPaid == 0 &&
            this.registration.coupon &&
            this.registration.coupon.discountAmount >= this.payment.totalPaid
        ) {
            this.registration.paymentMethodId =
                this.couponPaymentMethodPermission.id;
        }

        this.registration.payments = [];
        this.registration.payments.push(this.payment);

        let eventItem = new RegistrationEventDto();
        eventItem.name = this.event.name;
        eventItem.eventImage = this.event.eventImage;
        eventItem.beginDate = this.event.beginDate;
        eventItem.endDate = this.event.endDate;
        eventItem.place = this.event.place;

        let item: IRegistrationCart = {
            registration: this.registration,
            categoryDeadline: this.categoryDeadline,
            event: eventItem,
        };

        if (this.changeUser) {
            this.registration.user.emails.forEach((email) => {
                email.id = 0;
            });

            this.registration.user.phones.forEach((phone) => {
                phone.id = 0;
            });

            if (!this.registration.user.id) {
                this.registration.user.member =
                    new RegistrationUserMemberEditDto();
                this.registration.user.member.categories = [];

                let category = new MemberCategoryEditDto();
                category.categoryId = this.memberCategory.id;
                category.categoryLevelId = this.categoryLevelId;

                this.registration.user.member.categories.push(category);
            }
            this._cartHelperService.updateUserCart(
                this.registration.user,
                this.onLocal
            );
        }

        this._cartHelperService.addRegistrationToCart(item, this.onLocal);

        this._router.navigate(["app/store/cart"]);
    }

    validateRelatedEventRegistration() {
        if (this.event.relatedEvent) {
            return (
                (this.registration.user &&
                    this.registration.user.relatedEventRegistration ===
                    false) ||
                (this.registration.user && !this.registration.user.id)
            );
        }
        return false;
    }

    generateCredential(registrationId: number): void {
        this._registrationsService
            .getCredentials(
                false,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                [registrationId]
            )
            .subscribe((result) => {
                this._fileDownloadService.downloadTempFile(result);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/event/registration/registration.component.ts